import { Fragment, useState } from "react";
import ReactTooltip from "react-tooltip";
import { v4 as uuidv4 } from 'uuid';

export const TooltipStatement = (props) => {
    const { shorten, statement } = props;
    const [id] = useState(uuidv4())

    return (
        <Fragment>
            <p data-tip data-for={id}>
                {shorten}
            </p>
            <ReactTooltip id={id} place="top" effect="solid">
                {statement}
            </ReactTooltip>
        </Fragment>
    );
}